import { CreditCard } from "lucide-react";

// Badge informativo: pagamento PayPal con opzione "Paga in 3 rate senza interessi".
export const PaypalBadge = ({ className = "", testId }) => (
  <div
    data-testid={testId}
    className={`inline-flex items-center gap-1.5 rounded-lg border border-[#0070ba]/30 bg-[#0070ba]/10 px-2.5 py-1 text-[11px] font-medium leading-tight text-foreground ${className}`}
  >
    <CreditCard className="h-3.5 w-3.5 shrink-0 text-[#0070ba]" />
    <span>
      <strong style={{ color: "#0070ba" }}>PayPal</strong> · anche in 3 rate senza interessi
    </span>
  </div>
);
